
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

@Component({
	components: {
	}
})
export default class Numerical extends Vue {
	@Prop()
	cellData: any;

	private get value (): string {
		return this.cellData.value
	}

	private get description (): string {
		return this.cellData.description
	}

	private get cellClass (): string {
		return "bg-" + this.cellData.class
	}

	private get fontStyle (): any {
		if (this.cellData.value.toString().length > 10) {
			return {
				fontSize: "2.5rem"
			}
		} else if (this.cellData.value.toString().length > 5) {
			return {
				fontSize: "3rem"
			}
		} else {
			return {}
		}
	}
}
